import { useFeatureFlag } from '@moda/portal-stanchions';
import React from 'react';
import { LongReturnPolicyCopy } from './LongReturnPolicyCopy';
import {
  ReturnableReturnPolicy,
  ShortReturnPolicyCopy,
  ShortReturnPolicyCopyApproach
} from './ShortReturnPolicyCopy';

interface Props {
  approach?: ShortReturnPolicyCopyApproach;
  returnPolicy: ReturnableReturnPolicy;
  promoCodeApplied?: boolean;
  highlightDaysNumber?: boolean;
}

export const ReturnPolicyCopyReturnable: React.FC<Props> = ({
  promoCodeApplied = false,
  approach = ShortReturnPolicyCopyApproach.Plural,
  returnPolicy,
  highlightDaysNumber = false
}) => {
  const updatedReturnPolicyText = useFeatureFlag('updated-return-policy-text', [
    { default: false },
    { if: true, then: true }
  ]);

  if (updatedReturnPolicyText) {
    return (
      <ShortReturnPolicyCopy
        returnPolicy={returnPolicy}
        promoCodeApplied={promoCodeApplied}
        approach={approach}
        highlightDaysNumber={highlightDaysNumber}
      />
    );
  }

  return <LongReturnPolicyCopy returnPolicy={returnPolicy} promoCodeApplied={promoCodeApplied} />;
};
